import { SwiperOptions } from 'swiper/types';

const DESKTOP_BREAKPOINT = '1024';
export const EXPERIENCE_GALLERY_SWIPER_CONFIG: SwiperOptions = {
  breakpoints: {
    '0': {
      slidesPerView: 1,
    },
    [DESKTOP_BREAKPOINT]: {
      slidesPerView: 2.265,
    },
  },
  centeredSlides: true,
  initialSlide: 0,
  loop: true,
  a11y: {
    enabled: false,
  },
  navigation: {
    nextEl: `.next`,
    prevEl: `.prev`,
  },
};
